export const reportsApiPaths = <const>{
    reports: 'reports/select',
    report: 'reports/get',
    reportSchedule: 'reports/schedules/get',
    reportScheduleUpdate: 'reports/schedules/update',
};
